import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from './auth.service';
import { map, take } from 'rxjs/operators';

/**
 * Guard funcional para proteger rutas que requieren autenticación
 */
export const authGuard: CanActivateFn = (route, state) => {
    const authService = inject(AuthService);
    const router = inject(Router);

    // Si ya tenemos usuario, permitir acceso
    if (authService.isAuthenticated()) {
        return true;
    }

    // Si está cargando, esperar a que termine
    if (authService.isLoading()) {
        return authService.fetchCurrentUser().pipe(
            take(1),
            map((response) => {
                if (response.success && response.data) {
                    return true;
                }
                router.navigate(['/auth/login'], {
                    queryParams: { returnUrl: state.url },
                });
                return false;
            })
        );
    }

    // No autenticado, redirigir a login
    router.navigate(['/auth/login'], {
        queryParams: { returnUrl: state.url },
    });
    return false;
};

/**
 * Guard para redirigir usuarios ya autenticados fuera del login
 */
export const guestGuard: CanActivateFn = (route, state) => {
    const authService = inject(AuthService);
    const router = inject(Router);

    // Si ya está autenticado, redirigir al dashboard
    if (authService.isAuthenticated()) {
        router.navigate(['/dashboard']);
        return false;
    }

    // Si está cargando, esperar
    if (authService.isLoading()) {
        return authService.fetchCurrentUser().pipe(
            take(1),
            map((response) => {
                if (response.success && response.data) {
                    router.navigate(['/dashboard']);
                    return false;
                }
                return true;
            })
        );
    }

    return true;
};
